import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as BannerTileActions from '../../../../redux/actions/actions-banner-tile';
import { getBannerTileState } from '../../../../redux/reducers';
import { State as BannerState } from '../../../../redux/reducers/reducers-banner-tile';

@Component({
  standalone: false,
  selector: 'app-banner-tile',
  templateUrl: './banner-tile.component.html',
  styleUrls: ['./banner-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerTileComponent implements OnInit {
  @Input() type = 's';

  public banner$: Observable<BannerState>;
  public desktop = false;

  constructor(private readonly store: Store<any>) {}

  ngOnInit() {
    this.store.dispatch(BannerTileActions.GetBannerTile());
    this.banner$ = this.store.pipe(select(getBannerTileState));
  }

  openBanner(url) {
    const a = document.createElement('a');
    a.href = url.toString();
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  }
}
